/**
 * OVERRIDE MapsSidebar.jsx
 * REASON: Route field changes through dataAdapter to enforce default block width when floating.
 * DATE: 2026-04-16
 * DEVELOPER: @danalvrz
 */

import MapsSidebar from '../../../../../../components/Blocks/Maps/MapsSidebar';

export default MapsSidebar;
